import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight, CheckCircle2 } from "lucide-react";
import { useTimezone, fmtEvent, tzAbbr } from "@/lib/time";

function TeamRow({ abbr, name, score, showScore }) {
  return (
    <div className="flex items-center gap-3">
      <span className="flex h-9 w-11 items-center justify-center rounded-md border border-[#2A364F] bg-[#0F131D] font-display text-sm font-bold tracking-wider text-white">{abbr}</span>
      <div className="min-w-0 flex-1"><p className="truncate text-sm font-semibold text-white">{name}</p></div>
      {showScore && <span className="font-mono text-sm font-bold text-slate-200">{score}</span>}
    </div>
  );
}

const STATE_LABEL = { scheduled: "Scheduled", in_progress: "In Progress", final: "Final", postponed: "Postponed", canceled: "Cancelled", delayed: "Delayed", suspended: "Suspended" };

export function GameCard({ game, index = 0 }) {
  const { tz } = useTimezone();
  const live = game.status_state === "in_progress";
  const flagged = ["postponed", "canceled", "suspended", "delayed"].includes(game.status_state);
  return (
    <motion.article data-testid={`game-card-${game.id}`} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.4, delay: index * 0.05 }} className="card-mp card-hover p-5">
      <div className="mb-4 flex items-center justify-between gap-2">
        <span className={`tag border ${flagged ? "border-[#EF4444]/50 bg-[#EF4444]/10 text-[#EF4444]" : live ? "border-[#F59E0B]/50 bg-[#F59E0B]/10 text-[#F59E0B]" : "border-[#2A364F] bg-[#0F131D] text-slate-400"}`} data-testid={`game-time-${game.id}`}>
          {live && <span className="live-dot h-1.5 w-1.5 rounded-full bg-[#F59E0B]" />}
          {flagged || live ? STATE_LABEL[game.status_state] : `${fmtEvent(game.start_utc, tz)} ${tzAbbr(tz, game.start_utc)}`}
        </span>
        <span className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-wider text-slate-600"><CheckCircle2 size={10} className="text-[#00E676]" /> Verified · {game.league}</span>
      </div>
      <div className="space-y-3">
        <TeamRow abbr={game.away_abbr} name={game.away_name} score={game.away_score} showScore={live} />
        <TeamRow abbr={game.home_abbr} name={game.home_name} score={game.home_score} showScore={live} />
      </div>
      <Link to="/picks" data-testid={`view-matchup-btn-${game.id}`} className="mt-5 flex items-center justify-center gap-1 rounded-lg border border-[#2A364F] py-2.5 font-display text-xs font-bold uppercase tracking-wider text-slate-200 transition-colors hover:border-[#00E676]/50 hover:text-[#00E676]">
        View Picks For This Game <ChevronRight size={14} />
      </Link>
    </motion.article>
  );
}

export default GameCard;
